import { languageMap } from ".."

languageMap.trickle =
	languageMap.troy =
	languageMap.tremor =
		{
			comments: {
				line: "#",
			},
		}
